import {asset} from 'imba';
import url from './desktop.png';
export default asset({
	url: url,
	type: 'image',
	width: 2478,
	height: 1444,
	toString: function(){ return this.url;}
})